let currentRoute = window.location.pathname.replace(/^\//, '') || 'login';

export const setCurrentRoute = (route: string): void => {
  currentRoute = route;
};

export const getCurrentRoute = (): string => currentRoute;
